import { useEffect, useState } from 'react';

interface UseWindowIsResizingResult {
    windowIsResizing: boolean;
}

/**
 * A hook that tells whether the window is currently being resized. This state is updated once per
 * the refreshInterval.
 * @param refreshInterval
 */
export const useWindowIsResizing = (
    refreshInterval = 1000,
): UseWindowIsResizingResult => {
    const [windowIsResizing, setWindowIsResizing] = useState(false);

    useEffect((): (() => void | undefined) => {
        const timeoutIds: number[] = [];

        const handleWindowResize = (): void => {
            setWindowIsResizing(true);

            const timeoutId = window.setTimeout((): void => {
                setWindowIsResizing(false);
            }, refreshInterval);

            timeoutIds.push(timeoutId);
        };

        window.addEventListener('resize', handleWindowResize);

        return (): void => {
            window.removeEventListener('resize', handleWindowResize);

            for (const timeoutId of timeoutIds) {
                window.clearTimeout(timeoutId);
            }
        };
    }, []);

    return {
        windowIsResizing,
    };
};
